import { AnimatePresence, motion } from 'framer-motion';
import { X as XIcon, CheckCircle, Send, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';

export const BuddyPickerDialog = ({
  open,
  buddies,
  selectedIds,
  inviting,
  onToggle,
  onClose,
  onSend,
}) => (
  <AnimatePresence>
    {open && (
      <motion.div
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: 1, height: 'auto' }}
        exit={{ opacity: 0, height: 0 }}
        className="mt-3 bg-card border border-border rounded overflow-hidden"
        role="dialog"
        data-testid="buddy-picker-dialog"
      >
        <div className="p-3 border-b border-border flex items-center justify-between">
          <span className="text-white text-sm font-medium">
            Choose Buddies ({selectedIds.length}/4)
          </span>
          <button onClick={onClose} className="text-muted-foreground hover:text-white">
            <XIcon className="h-4 w-4" />
          </button>
        </div>
        {buddies.length === 0 ? (
          <div className="p-4 text-center text-muted-foreground text-sm">
            No buddies yet. Add buddies from the Social page!
          </div>
        ) : (
          <>
            <div className="max-h-48 overflow-y-auto">
              {buddies.map(buddy => {
                const isSelected = selectedIds.includes(buddy.id);
                return (
                  <button
                    key={buddy.id}
                    onClick={() => onToggle(buddy.id)}
                    className={`w-full flex items-center gap-3 p-3 transition-colors text-left ${
                      isSelected ? 'bg-primary/10' : 'hover:bg-white/5'
                    }`}
                    data-testid={`invite-buddy-${buddy.id}`}
                  >
                    <div className={`h-8 w-8 rounded-full flex items-center justify-center text-sm font-bold ${
                      isSelected ? 'bg-primary text-black' : 'bg-primary/20 text-primary'
                    }`}>
                      {isSelected ? <CheckCircle className="h-5 w-5" /> : buddy.name?.charAt(0)}
                    </div>
                    <span className="text-white text-sm flex-1">{buddy.name}</span>
                  </button>
                );
              })}
            </div>
            {selectedIds.length > 0 && (
              <div className="p-3 border-t border-border">
                <Button
                  onClick={onSend}
                  disabled={inviting}
                  className="w-full bg-primary text-black"
                  data-testid="send-buddy-invite-btn"
                >
                  {inviting ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Send className="h-4 w-4 mr-2" />}
                  Invite {selectedIds.length} Budd{selectedIds.length > 1 ? 'ies' : 'y'}
                </Button>
              </div>
            )}
          </>
        )}
      </motion.div>
    )}
  </AnimatePresence>
);
